import { makeAutoObservable } from "mobx"

export default class CommentLocation {

  constructor(location = {}) {
    this.id = location.id
    this.top = location.top
    this.left = location.left
    this.time = location.time
    this.locationOwnerName = location.location_owner_name
    this.locationOwnerAvatar = location.location_owner_avatar
    this.isAccepted = location.is_accepted
    this.comments =  []

    makeAutoObservable(this)
  }
}
